
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "../../baseApiClient";
import { logger } from "@/lib/logger";
import { BusinessData } from "../types";
import { businessMapper } from "../mappers";

/**
 * Fetches a business by its ID
 */
export async function fetchBusinessById(businessId: string): Promise<BusinessData | null> {
  return BaseApiClient.request<BusinessData | null>(
    `business:${businessId}`,
    async () => {
      try {
        const { data, error } = await supabase
          .from('business')
          .select('*')
          .eq('id', businessId)
          .maybeSingle();
        
        if (error) {
          throw new Error(`Failed to fetch business: ${error.message}`);
        }
        
        // If no data found, return null
        if (!data) return null;
        
        // Convert database record to frontend format
        return businessMapper.toFrontend(data);
      } catch (error) {
        logger.error({
          message: "Error fetching business",
          error: error instanceof Error ? error : new Error(String(error)),
          context: { businessId }
        });
        throw error;
      }
    }
  );
}
